export default {
  how_to_place_order: {
    header: 'Wie gebe ich eine Bestellung auf?',
    body: 'Stöbern Sie einfach im Menü, fügen Sie Artikel zu Ihrem Warenkorb hinzu und folgen Sie den Schritten zum Bezahlen. Sie erhalten eine Bestätigung, sobald die Bestellung aufgegeben wurde.',
  },
  schedule_order: {
    header: 'Kann ich eine Bestellung im Voraus planen?',
    body: 'Ja! Wählen Sie beim Bezahlen die Option „Planen“, um eine zukünftige Abholzeit zu wählen, die Ihnen am besten passt.',
  },
  customize_order: {
    header: 'Kann ich meine Bestellung anpassen?',
    body: 'Absolut. Tippen Sie auf ein Menüelement, um Anpassungsoptionen wie Toppings, Beilagen und Präferenzen zu sehen.',
  },
  track_order: {
    header: 'Wie verfolge ich meine Bestellung?',
    body: 'Nach dem Aufgeben Ihrer Bestellung sehen Sie Echtzeit-Updates in der App – von der Bestätigung über die Zubereitung bis zur Abholbereitschaft.',
  },
  cancel_or_edit_order: {
    header: 'Kann ich meine Bestellung nach dem Aufgeben stornieren oder ändern?',
    body: 'Falls Ihre Bestellung noch nicht in der Zubereitung ist, können Sie Änderungen anfordern, indem Sie das Restaurant direkt über die App kontaktieren.',
  },
  payment_methods: {
    header: 'Welche Zahlungsmethoden akzeptieren Sie?',
    body: 'Wir akzeptieren gängige Kredit-/Debitkarten, Apple Pay und Google Pay, je nach Ihrem Gerät.',
  },
  no_confirmation: {
    header: 'Ich habe keine Bestätigung erhalten. Was soll ich tun?',
    body: 'Überprüfen Sie den Spam-Ordner Ihrer E-Mails oder gehen Sie zum Reiter „Bestellungen“ in der App. Falls Sie sie immer noch nicht finden, kontaktieren Sie das Restaurant direkt.',
  },
  pickup_instructions: {
    header: 'Wo hole ich meine Bestellung ab?',
    body: 'Abholanweisungen werden auf dem Bestätigungsbildschirm und in Ihrer Bestellübersicht angezeigt. Achten Sie auf Beschilderungen oder fragen Sie das Personal bei Ihrer Ankunft.',
  },
  loyalty_points: {
    header: 'Kann ich mit meinen Bestellungen Treuepunkte sammeln?',
    body: 'Ja, berechtigende Käufe sammeln automatisch Punkte. Sie können Ihr Guthaben und Ihre Prämien auf dem Hauptbildschirm der App einsehen.',
  },
  apply_promo_code: {
    header: 'Wie wende ich einen Aktionscode oder Rabatt an?',
    body: 'Während des Bezahlvorgangs sehen Sie eine Option, um einen Aktionscode einzugeben. Verfügbare Rabatte werden auch automatisch angewendet, falls Sie berechtigt sind.',
  },
  issue_with_order: {
    header: 'Was soll ich tun, wenn es ein Problem mit meiner Bestellung gibt?',
    body: 'Wir sind hier, um zu helfen. Kontaktieren Sie das Restaurant über die App oder senden Sie eine E-Mail direkt an den Support über die Option „Support kontaktieren“.',
  },
  use_loyalty_and_coupon: {
    header:
      'Kann ich Treuepunkte und einen Gutschein (wie „Kauf 1, erhalte 1 gratis“) für dieselbe Bestellung verwenden?',
    body: 'Nein – pro Bestellung kann nur ein Rabatt oder Angebot angewendet werden. Dies gewährleistet eine faire Nutzung von Prämien und Aktionen. Wählen Sie die Option, die Ihnen den besten Wert bietet!',
  },
};
